import styled from 'styled-components'

export const Card = styled.div`
    display: grid;
    grid-template-columns: 60px 1fr;
    gap: 16px;
    align-items: flex-start;
    background: white;
    border-radius: 16px;
    padding: 18px;
    box-shadow: 0 3px 10px rgba(42, 76, 129, 0.12);
    border: 1px solid #dde6f3;

    @media (max-width: 1000px) {
        grid-template-columns: 50px 1fr;
    }
`

export const Number = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #4a6fb0;
    text-align: center;
    padding-top: 6px;
`

export const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const Name = styled.div`
    font-size: 22px;
    font-weight: 700;
    color: #355486;
`

export const Group = styled.div`
    color: #687b98;
    font-size: 14px;
`
